export const getBuilderConfigURL = () => {
  let domainName = window.location.hostname;

  let redirectUrl = `https://${domainName}/`;
  if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
    redirectUrl = `http://${domainName}:9075/`;
  } else if (process.env.REACT_APP_ENVIRONMENT === 'STAGING') {
    domainName = domainName.replace('builder.webkonnect.digital', 'builderc.webkonnect.digital');
    redirectUrl = `https://${domainName}/`;
  } else {
    domainName = domainName.replace('builder.mydrapcode.com', 'builderc.mydrapcode.com');
    redirectUrl = `https://${domainName}/`;
  }
  return redirectUrl;
};
